import { SELF, VERIFIED } from "../../internal/shared/permissions/symbols";
/**
 * @see https://sail.stripe.me/data/api/getVerifiedToken
 */ export default function getVerifiedToken(/** The array of permissions that the token should contain */ permissions) {
    const self = {};
    permissions.forEach((permission)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<SailDataPermissions>'. | No index signature with a parameter of type 'string' was found on type 'Partial<SailDataPermissions>'.
        self[permission] = true;
    });
    return {
        [SELF]: self,
        [VERIFIED]: true
    };
}

//# sourceMappingURL=getVerifiedToken.js.map